import Vue from "vue";
import VueRouter from "vue-router";
import Dictionary from "../components/Dictionary";
import HomePage from "../components/HomePage";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Main',
    component: HomePage
  },

  {
    path: '/dictionary',
    name: 'Dictionary',
    component: Dictionary
  },
]

const router = new VueRouter({
  mode: "history",
  routes
})

export default router;
